import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", {
  style: {
    "padding": "0 16px"
  }
}, "客户查询", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_search = _resolveComponent("van-search");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.show = $event),
    closeable: "",
    position: "bottom",
    style: {
      height: '80%'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_1, _createVNode(_component_van_search, {
      modelValue: $data.searchValue,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.searchValue = $event),
      "show-action": "",
      placeholder: $data.searchTypeRes.join('/'),
      onSearch: $options.onSearch
    }, {
      label: _withCtx(() => [_createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = $event => $options.onSearchTypeClick($data.searchType))
      }, _toDisplayString($data.searchType), 1)]),
      action: _withCtx(() => [_createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = (...args) => $options.onSearch && $options.onSearch(...args)),
        size: "small"
      }, "查询")]),
      _: 1
    }, 8, ["modelValue", "placeholder", "onSearch"]), _createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm,
      immediateCheck: false
    }, {
      default: _withCtx(({
        item
      }) => [_createVNode(_component_van_divider, {
        style: {
          padding: '0',
          margin: '0',
          borderColor: '#999'
        }
      }), _createVNode(_component_van_cell, {
        clickable: "",
        title: '客户号: ' + item.customerNo,
        value: item.chnName,
        onClick: $event => $options.onListItemClick(item)
      }, null, 8, ["title", "value", "onClick"]), _createVNode(_component_van_cell, {
        style: {
          "padding-top": "0"
        },
        clickable: "",
        title: item.mobile,
        value: item.idNo,
        onClick: $event => $options.onListItemClick(item)
      }, null, 8, ["title", "value", "onClick"])]),
      _: 1
    }, 8, ["request", "requestParameter"])])]),
    _: 1
  }, 8, ["show"]);
}